<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="search-popup-overlay" (click)="handleClose()" (keydown)="$event.key === 'Escape' && handleClose()" aria-label="Close search overlay"></div>

<div class="search-popup" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
  <div class="search-popup-header">
    <div class="search-input-container">
      <i class="pi pi-search search-icon"></i>
      <input
        type="text"
        class="search-input"
        placeholder="Search users, RCAs, responses..."
        [value]="searchQuery"
        (input)="handleSearchInput($event)"
        autocomplete="off"
        autofocus
      />
      <button class="close-btn" (click)="handleClose()" aria-label="Close search">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <div class="search-popup-body">
    <!-- Loading state -->
    <div *ngIf="isLoading" class="loading-state">
      <i class="pi pi-spinner pi-spin"></i>
      <span>Searching...</span>
    </div>

    <!-- Empty state when no query -->
    <div *ngIf="!isLoading && !searchQuery" class="empty-state">
      <i class="pi pi-search"></i>
      <p>Start typing to search across users, RCAs, and responses</p>
      <small>Minimum 2 characters required</small>
    </div>

    <!-- No results state -->
    <div *ngIf="!isLoading && searchQuery && searchQuery.length >= 2 && results.length === 0" class="no-results">
      <i class="pi pi-info-circle"></i>
      <p>No results found for "{{ searchQuery }}"</p>
      <small>Try different keywords</small>
    </div>

    <!-- Results list -->
    <div *ngIf="!isLoading && results.length > 0" class="results-container">
      <div class="results-header">
        <span class="results-count">{{ totalResults }} result{{ totalResults !== 1 ? 's' : '' }} found</span>
      </div>
      
      <div class="results-list">
        <button
          *ngFor="let result of results"
          class="result-item"
          (click)="handleResultClick(result)"
          type="button"
        >
          <div class="result-icon-container">
            <i [class]="getResultIcon(result.type)"></i>
          </div>
          <div class="result-content">
            <div class="result-header-row">
              <h4 class="result-title">{{ result.title }}</h4>
              <span *ngIf="result.type" class="result-type-badge">{{ getResultTypeLabel(result.type) }}</span>
            </div>
            <p class="result-subtitle">{{ result.subtitle }}</p>
            <p class="result-description" *ngIf="result.description">
              {{ truncate(result.description, 120) }}
            </p>
            <span *ngIf="result.status" class="result-status">{{ result.status }}</span>
          </div>
          <div class="result-arrow">
            <i class="pi pi-arrow-right"></i>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
